// extracted by mini-css-extract-plugin
module.exports = {"tabBarItem":"TabBarItem_tabBarItem__1MbIU","isCurrentTab":"TabBarItem_isCurrentTab__FU3-b","fillBar":"TabBarItem_fillBar__1ZT9V"};